module.exports = __webpack_public_path__ + "media/images/escadotes/escadote_7-073f2f24c0c51854d93ecf09a3440106.png";